<template>
  <div>
    <v-dialog persistent v-model="dialogAbrirCaixa" max-width="750px">
      <abrir-caixa
        v-if="dialogAbrirCaixa"
        @close="dialogAbrirCaixa = false"
        @response="caixaAberto"
      />
    </v-dialog>
    <div class="p-lg-3 my-3">
      <div class="row align-center justify-content-center" style="gap: 2rem">
        <div class="card-comanda-valor color-selecionado">
          <div class="title-card">
            Valor Total Selecionado
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(sum)
            }}
          </div>
        </div>
        <div class="card-comanda-valor color-total">
          <div class="title-card">
            Valor Original
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(valorOriginalComanda())
            }}
          </div>
        </div>
        <div class="card-comanda-valor color-desconto">
          <div class="title-card">
            Desconto Aplicado
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(descontoValor)
            }}
          </div>
        </div>
        <div class="card-comanda-valor color-cobrado">
          <div class="title-card">
            Valor Cobrado
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(valorOriginalComanda() - descontoValor)
            }}
          </div>
        </div>
        <div class="card-comanda-valor color-pago">
          <div class="title-card">
            Valor Pago
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(valorPagoComanda)
            }}
          </div>
        </div>
        <div class="card-comanda-valor color-estornado">
          <div class="title-card">
            Valor Estornado
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(valorTotalEstornado)
            }}
          </div>
        </div>
        <div class="card-comanda-valor color-credito">
          <div class="title-card">
            Crédito Cliente
          </div>
          <div class="content-card">
            {{
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(valorCreditoCliente)
            }}
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialogCodigoAuth" v-if="dialogCodigoAuth" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Pagamento </v-card-title>

        <v-text-field
          class="mx-5 pt-5"
          label="Bandeira do cartão"
          required
          v-model="bandeira"
          v-if="isCard"
        ></v-text-field>

        <v-text-field
          class="mx-5"
          label="Código de autorização"
          required
          v-model="codAuth"
          v-if="isCard"
        ></v-text-field>

        <v-text-field
          class="mx-5"
          label="Número de Parcelas"
          v-if="isCard & isCreditCard"
          required
          v-model="parcelas"
        ></v-text-field>

        <textarea
          rows="4"
          cols="58"
          class="mt-5 p-2 border"
          placeholder="Observações"
          maxlength="400"
          v-model="observacao"
        ></textarea>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mb-2"
            type="number"
            text
            color="error"
            @click="dialogCodigoAuth = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="success"
            class="mb-2"
            type="number"
            @click="marcarPago(codAuth, bandeira)"
            v-if="isCard"
            :disabled="!codAuth"
          >
            Marcar Pago
          </v-btn>
          <v-btn
            color="success"
            class="mb-2"
            type="number"
            @click="marcarPago(0, 0)"
            v-if="!isCard"
          >
            Marcar Pago
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="col-12" v-if="!loading">
      <v-tabs v-model="tab" background-color="transparent" grow>
        <v-tab key="aberto">
          Em Aberto
        </v-tab>
        <v-tab key="pagos" :disabled="dessertsPago.length == 0">
          Pagos
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="aberto">
          <div class="container-fluid my-5">
            <div class="row justify-content-between px-4">
              <div>
                <h2 class="text-start">Aberto</h2>
              </div>
              <div>
                <v-btn
                  class="success"
                  @click="pagarItens"
                  v-if="
                    (valorPagoComanda != valorOriginalComanda()) &
                      comanda.comandaEstaAberta &
                      (valorOriginalComanda() > 0) &
                      (perfil.id == 56 || perfil.id == 1)
                  "
                  small
                  :disabled="itemsEstorno.length > 0 || selected.length == 0"
                >
                  Pagar
                </v-btn>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="dessertsAberto"
                  item-key="comanda_item_id"
                  show-select
                  class="elevation-1"
                  @toggle-select-all="selectAllToggle"
                >
                  <template v-slot:item.valor="{ item }">
                    {{  parseFloat(item.valor_original).toLocaleString("pt-br", {
             style: "currency",
            currency: "BRL",
           }), }}
                  </template>
                  <template v-slot:header.data-table-select="{}">
                    <v-simple-checkbox
                      @input="selectAllToggle"
                      :value="selectedAll"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      color="error"
                      @click="excluirItemComanda(item)"
                      title="EXCLUIR"
                      v-if="
                        comanda.comandaEstaAberta &
                          (item.status == 1) &
                          (perfil.id == 56 || perfil.id == 1) &
                          (item.id_status_requisicao == 1)
                      "
                    >
                      mdi mdi-close-thick
                    </v-icon>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item key="pagos">
          <div class="container-fluid my-5">
            <div class="row justify-content-between px-4">
              <div>
                <h2 class="text-start">Pagos</h2>
              </div>
              <div>
                <div style="display: flex; gap: 2rem" class="align-center mr-5">
                  <v-icon
                    @click="showDialogEstorno"
                    title="LANÇAR ESTORNO"
                    x-large
                    color="grey darken-3"
                    v-if="
                      (valorOriginalComanda() > 1) &
                        (itemsEstorno.length > 0) &
                        (perfil.id == 56 || perfil.id == 1)
                    "
                  >
                    mdi-cash-sync
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <v-data-table
                  :headers="headersPago"
                  :items="dessertsPago"
                  class="elevation-1"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="
                        (item.comanda_item_status_id == 4) &
                          (perfil.id == 56 || perfil.id == 1)
                      "
                      text
                      rounded
                      title="Gerar recibo de estorno"
                      @click="reciboEstornoPDF(item.extorno_id)"
                    >
                      <v-icon>mdi-printer-outline</v-icon>
                    </v-btn>
                    <v-icon
                      color="error"
                      @click="excluirItemComanda(item)"
                      title="EXCLUIR"
                      v-if="
                        comanda.comandaEstaAberta &
                          (item.comanda_item_status_id == 1) &
                          (perfil.id == 56 || perfil.id == 1)
                      "
                    >
                      mdi mdi-close-thick
                    </v-icon>
                    <v-btn
                      title="ESTORNAR"
                      v-if="
                        (item.comanda_item_status_id == 2) &
                          (perfil.id == 56 || perfil.id == 1)
                      "
                      small
                      :color="checkEstorno(item) ? 'success' : 'gray'"
                      :text="!checkEstorno(item)"
                      class="border"
                      @click="selectItemEstorno(item)"
                    >
                      <span class="text-grey">
                        Estornar
                      </span>
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <v-progress-circular
        class="mt-5"
        width="3"
        size="50"
        indeterminate
        color="#1daf80"
      ></v-progress-circular>
    </div>
    <template v-if="dialogPagarComandas">
      <v-dialog
        v-model="dialogPagarComandas"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <ModalPagarComandas
          :comandas="selected"
          @close="dialogPagarComandas = false"
          @response="itensPagos"
        />
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogEstorno" v-if="dialogEstorno" max-width="500px">
        <v-card>
          <v-toolbar dark class="mb-2 bg-verde">
            <v-btn icon dark @click="dialogEstorno = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Lançar Estorno</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items> </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="mt-5 mx-auto">
            <h3>Valor do estorno: R$ {{ estornarValorTotal }}</h3>
            <v-select
              :items="tiposEstorno"
              item-text="descricao"
              label="Tipos de estorno"
              outlined
              class="mt-5"
              v-model="tipoEstornoSelecionado"
              return-object
            ></v-select>
            <v-textarea
              outlined
              label="Observações"
              v-model="observacoesEstorno"
              rows="3"
            ></v-textarea>
          </v-card-text>
          <v-card-actions class="justify-end pb-5 mr-2">
            <v-btn text @click="dialogEstorno = false">Cancelar</v-btn>
            <v-btn
              @click="estornar"
              color="success"
              :disabled="
                !tipoEstornoSelecionado.id ||
                  estornarValorTotal < 1 ||
                  loadingEstorno
              "
              style="width: 120px"
            >
              <span v-if="!loadingEstorno">Estornar</span>
              <v-progress-circular
                v-else
                :width="3"
                :size="20"
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Recibo-estorno"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="html2Pdf"
        >
          <section slot="pdf-content" class="m-4 pdf-content">
            <div class="text-center">
              <img
                src="@/assets/images/logo_sistema.jpg"
                alt="logo"
                width="100px"
              />
              <!-- <img
                src="../../assets/images/logo_caes_gatos.jpg"
                alt="logo cães e gatos"
                width="50px"
              /> -->
            </div>
            <h3 class="text-center mb-5" style="margin-top: 1rem">
              RECIBO DE ESTORNO
            </h3>
            <p class="text-justify">
              Eu, <b>{{ nome_cliente }}</b
              >, CPF <b>{{ tutor.cpf }}</b
              >, recebi de {{ unidade.razao_social }}, endereço:
              {{
                unidade.logradouro +
                  " - " +
                  unidade.bairro +
                  " | " +
                  unidade.cidade +
                  "/" +
                  unidade.estado
              }}, CNPJ: {{ unidade.cnpj }}, o valor de
              {{
                new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(valorEstornoRecibo)
              }}, referente a não prestação dos serviços:
              {{ itemsReciboEstorno.map((item) => item.desc).join(", ") }}.
            </p>
            <p>Forma de estorno: {{ tipoEstornoRecibo.descricao }}</p>
            <p>
              Este documento dá quitação plena e irrevogável da referência
              acima.
            </p>
            <p class="d-flex justify-content-center mt-5">
              {{ unidade.cidade }}/{{ unidade.estado }},
              <b>{{ dataEstorno }}</b>
            </p>

            <p class="text-center">
              _________________________________________
            </p>
            <p class="text-center mt-n2">{{ nome_cliente }}</p>
          </section>
        </vue-html2pdf>
      </div>
    </template>
  </div>
</template>
<style scoped></style>
<script>
import Mixin from "@/mixins/vuex_mixin.js";
import ComandaService from "@/services/comanda_service.js";
import FormaPagamentoService from "../../services/forma_pagamento_service";
import TipoEstornoService from "@/services/tipo_estorno_service.js";
import EstornoService from "@/services/estorno_service.js";
import CaixaService from "@/services/caixa_service.js";
import VuexSnackbarMixin from "@/mixins/vuex_snackbar_mixin.js";
import ModalPagarComandas from "@/components/pacientes/modal_pagar_comandas.vue";
import VueHtml2pdf from "vue-html2pdf";
import CreditoClienteService from "../../services/credito_cliente_service";
import AbrirCaixa from "@/components/caixa/abertura-caixa.vue";
import ExternoEvento from "@/router/eventExterno.js";

export default {
  mixins: [Mixin, VuexSnackbarMixin],
  components: {
    ModalPagarComandas,
    VueHtml2pdf,
    AbrirCaixa,
  },
  data: () => ({
    codAuth: null,
    dialogPagarComandas: false,
    disabledCount: 0,
    dialogClose: false,
    parcelas: 0,
    singleSelect: false,
    selected: [],
    sum: 0,
    observacao: "",
    dialogDetalhesComandas: false,
    isCard: false,
    isCreditCard: false,
    dialogCodigoAuth: false,
    comandasItens: [],
    loading: false,
    formasdePagamento: [],
    formaPagamentoSelecionada: {},
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "comanda_item_id",
      },
      {
        text: "Procedimento",
        align: "start",
        sortable: false,
        value: "procedimentoDescricao",
      },
      {
        text: "Tipo Procedimento",
        align: "start",
        sortable: false,
        value: "tipoProcedimentoDescricao",
      },
      {
        text: "Valor",
        align: "start",
        sortable: false,
        value: "valor",
      },
      {
        text: "Convênio",
        align: "start",
        sortable: false,
        value: "convenioDescricao",
      },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "statusDescricao",
      },
      { text: "Data criado", value: "dataCriado", sortable: false },
      { text: "", align: "center", value: "actions", sortable: false },
      // { text: "Pagar", align: "center", value: "select", sortable: false },
    ],
    headersPago: [
      {
        text: "Procedimento",
        align: "start",
        sortable: false,
        value: "procedimento",
      },
      {
        text: "Tipo Procedimento",
        align: "start",
        sortable: false,
        value: "tipo_procedimento",
      },
      {
        text: "Valor Original",
        align: "start",
        sortable: false,
        value: "valor_original_formatado",
      },
      {
        text: "Valor Pago",
        align: "start",
        sortable: false,
        value: "valor_cobrado_formatado",
      },
      {
        text: "Convênio",
        align: "start",
        sortable: false,
        value: "convenio",
      },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "item_status",
      },
      { text: "Data criado", value: "data_formatado", sortable: false },
      { text: "", align: "center", value: "actions", sortable: false },
      // { text: "Pagar", align: "center", value: "select", sortable: false },
    ],
    desserts: [],
    dessertsAberto: [],
    dessertsPago: [],
    descontoValor: 0,
    comandaService: ComandaService.build(),
    formaPagamentoService: FormaPagamentoService.build(),
    tipoEstornoService: TipoEstornoService.build(),
    estornoService: EstornoService.build(),
    caixaService: CaixaService.build(),
    dialogEstorno: false,
    tiposEstorno: [],
    tipoEstornoSelecionado: {},
    valorEstorno: null,
    valorTotalEstornado: null,
    observacoesEstorno: "",
    valorExcedido: false,
    bandeira: "",
    valorPagoComanda: null,
    loadingEstorno: false,
    unidade: {},
    usuario: {},
    valorEstornoRecibo: "",
    dataEstorno: "",
    itemsEstorno: [],
    valorCreditoCliente: "",
    itemsReciboEstorno: [],
    forma_devolucao: "",
    perfil: null,
    nome_cliente: "",
    tipoEstornoRecibo: "",
    unidadeLogada: ~~JSON.parse(sessionStorage.vuex).unidade.id,
    usuarioLogada: ~~JSON.parse(sessionStorage.vuex).usuario.id,
    infoCaixa: {},
    dialogAbrirCaixa: false,
    acao: "",
    tab: "",
  }),
  props: {
    comanda: {
      type: Object,
      required: true,
    },
    tutor: {
      required: true,
    },
  },
  watch: {
    comanda() {
      this.comandasItens = [];
      this.setComandaItens();
    },

    dialogClose() {
      if (this.dialogClose === true) {
        this.dialogPagarComandas = false;
        this.$emit("close");
      }
    },

    selected() {
      //let sum = 0
      this.sum = 0;
      // console.log(this.selected);
      for (let i = 0; i < this.selected.length; i++) {
        // this.sum = this.sum + parseFloat(this.selected[i].valor);
        this.sum = this.sum + parseFloat(this.selected[i].valor_original);
      }
    },
    close() {
      this.dialogPagarComandas = false;
      this.$emit("close");
    },
    dialogCodigoAuth() {
      this.observacao = "";
      this.bandeira = "";
      this.bandeira = "";
      this.codAuth = null;
    },
    tipoEstornoSelecionado() {
      // console.log(this.tipoEstornoSelecionado);
    },
    desserts() {
      this.dessertsAberto = [];
      // this.dessertsPago = [];
      for (let index = 0; index < this.desserts.length; index++) {
        const element = this.desserts[index];
        if (element.status == "1") {
          this.dessertsAberto.push(element);
        }
        //  else {
        //   this.dessertsPago.push(element);
        // }
      }
    },
  },
  beforMount() {
    document.getElementsByTagName("i")[0].style("display:none;");
  },
  async mounted() {
    this.perfil = JSON.parse(sessionStorage.vuex).perfil;
    await this.setComandaItens();
    this.getFormasPagamento();
    // const self = this;
    // this.desserts.map((item) => {
    //   if (item.status != 1 || item.tipo_convenio_id == 1) {
    //     self.disabledCount += 1;
    //   }
    // });
    this.comandasItens.map((item) => {
      if (item.status == 2) {
        this.formaPagamentoSelecionada = Object.assign(
          this.formaPagamentoSelecionada,
          { [item.comanda_item_id]: item.id_forma_pagamento }
        );
      }
    });
    this.unidade = JSON.parse(sessionStorage.getItem("vuex")).unidade;
    await this.getTiposEstorno();
    this.valoresEstornados();
  },
  // created() {
  //   const self = this;
  //   this.desserts.map((item) => {
  //     if ((item.status == 1) & (item.tipo_convenio_id != 1))
  //       self.disabledCount += 1;
  //   });
  // },
  methods: {
    async getCreditoCliente() {
      const creditoClienteService = new CreditoClienteService();
      const unidadeId = JSON.parse(sessionStorage.getItem("vuex")).unidade.id;
      const clienteId = this.comanda.cliente_id;

      const credito = await creditoClienteService.getCreditosCliente(
        unidadeId,
        clienteId
      );

      const creditos = await credito.data.creditos;
      this.valorCreditoCliente = creditos.reduce(
        (acc, cur) => acc + parseFloat(cur.valor),
        0
      );
    },
    selectItemEstorno(item) {
      const itemEmEstorno = this.itemsEstorno.filter(
        (itemEstorno) => itemEstorno.comanda_item_id == item.comanda_item_id
      );
      if (itemEmEstorno.length == 0) {
        this.itemsEstorno.push({
          comanda_item_id: item.comanda_item_id,
          comanda_fechamento_id: item.comanda_fechamento_id,
          valor: parseFloat(item.valor_cobrado),
        });

        this.itemsReciboEstorno.push({
          comanda_item_id: item.comanda_item_id,
          comanda_fechamento_id: item.comanda_fechamento_id,
          desc: item.procedimento,
        });
        // console.log(this.itemsReciboEstorno);

        // this.$refs[item.comanda_item_id].text = true;
        // this.$refs[item.comanda_item_id].color = "grey";
      } else {
        this.itemsEstorno = this.itemsEstorno.filter(
          (itemEstorno) => itemEstorno.comanda_item_id != item.comanda_item_id
        );

        this.itemsReciboEstorno = this.itemsReciboEstorno.filter(
          (itemEstorno) => itemEstorno.comanda_item_id != item.comanda_item_id
        );
        // console.log(this.itemsReciboEstorno);

        // this.$refs[item.comanda_item_id].text = false;
        // this.$refs[item.comanda_item_id].color = "success";
      }
    },
    async reciboEstornoPDF(estornoId) {
      await this.estornoService
        .getReciboEstorno(estornoId)
        .then((resp) => resp.data.dados_recibo[0])
        .then((resp) => {
          this.usuario = {
            nome: resp.colaborador,
          };
          this.valorEstornoRecibo = resp.valor;
          this.nome_cliente = resp.nome_cliente;
          this.pet_nome = resp.pet_nome;
          this.tipoEstornoRecibo = this.tiposEstorno.find(
            (tipo) => tipo.id == resp.id_tipo_extorno
          );

          const meses = [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ];
          let data = new Date();
          let dataFormatada =
            data.getDate() +
            " " +
            meses[data.getMonth()] +
            " " +
            data.getFullYear();
          this.dataEstorno = dataFormatada;
        })
        .then(() => {
          this.$refs.html2Pdf.generatePdf();
        })
        .catch((error) => console.log(error));
    },
    selecionarFormaPagamento(event, id) {
      this.formaPagamentoSelecionada = Object.assign(
        this.formaPagamentoSelecionada,
        { [id]: event }
      );
    },
    selectAllToggle() {
      if (
        this.selected.length ==
        this.dessertsAberto.length - this.disabledCount
      ) {
        // if (this.selected.length == this.desserts.length - this.disabledCount) {
        this.selected = [];
      } else {
        this.selected = [];
        this.dessertsAberto.forEach((item) => {
          // this.desserts.forEach((item) => {
          if ((item.status == 1) & (item.tipo_convenio_id != 1)) {
            this.selected.push(item);
          }
        });
      }
    },
    async getFormasPagamento() {
      this.formasdePagamento = await this.formaPagamentoService
        .getFormaPagamentoPaginatedList()
        .then((resp) => resp.json())
        .then((resp) => {
          return resp.data.forma_pagamento.map((item) => {
            return { text: item.descricao, id: item.id, codauth: item.codauth };
          });
        });
    },
    async setComandaItens() {
      this.loading = true;
      const response = await this.comandaService.getComandaItensByComandaId(
        this.comanda.comanda_id
      );
      const responsePago = await this.comandaService.getComandaItensPagosByComandaId(
        this.comanda.comanda_id
      );
      this.dessertsPago = [];
      this.dessertsAberto = [];
      this.valorPagoComanda = 0;
      this.descontoValor = 0;
      this.desserts = await response.map((item) => {
        return {
          ...item,
          procedimentoDescricao: item.procedimento_descricao,
          tipoProcedimentoDescricao: item.tipo_procedimento_descricao,
          valor: item.valor,
          convenioDescricao: item.tipo_convenio_descricao,
          statusDescricao: item.status_requisicao,
          idStatusDescricao: item.id_status_requisicao,
          isPago: item.status == 2,
          dataCriado: new Date(
            item.data_criada + " " + item.hora_criada
          ).toLocaleString("pt-BR"),
        };
      });
      for (let index = 0; index < responsePago.length; index++) {
        const fechamento = responsePago[index].fechamento;
        this.descontoValor =
          this.descontoValor + parseFloat(fechamento.desconto_valor);
        const detalhe = responsePago[index].detalhe;
        for (
          let indexDetalhe = 0;
          indexDetalhe < detalhe.length;
          indexDetalhe++
        ) {
          const element = detalhe[indexDetalhe];
          const newItem = {
            ...element,
            valor_original_formatado: this.convertMoeda(element.valor_original),
            valor_cobrado_formatado: this.convertMoeda(element.valor_cobrado),
            data_formatado: new Date(
              element.data_criacao + " " + element.hora_criacao
            ).toLocaleString("pt-BR"),
          };
          this.dessertsPago.push(newItem);
          if (element.comanda_item_status_id == "2") {
            this.valorPagoComanda =
              this.valorPagoComanda + parseFloat(element.valor_cobrado);
          }
        }
        // const fechamento = response2[index].fechamento;
      }
      // this.valorPagoComanda = response
      //   .filter((item) => item.status == "2")
      //   .reduce((acc, cur) => {
      //     return acc + parseFloat(cur.valor);
      //   }, 0);
      // this.valorPagoComanda = responsePago
      //   .filter((item) => item.comanda_item_status_id == "2")
      //   .reduce((acc, cur) => {
      //     return acc + parseFloat(cur.valor_cobrado);
      //   }, 0);
      this.getCreditoCliente();
      this.loading = false;
    },
    codigoAuth(item) {
      let payMethod = 0;

      for (let prop in this.formaPagamentoSelecionada) {
        if (prop === item.comanda_item_id) {
          payMethod = this.formaPagamentoSelecionada[prop];
        }
      }
      if (payMethod === "1") {
        this.parcelas = 1;
        this.isCreditCard = true;
      } else {
        this.parcelas = 0;
        this.isCreditCard = false;
      }
      localStorage.setItem("itemComanda", JSON.stringify(item));

      const auth = this.formasdePagamento.filter((formPag) => {
        return (
          formPag.id == this.formaPagamentoSelecionada[item.comanda_item_id]
        );
      })[0].codauth;

      if (auth == "S") {
        this.isCard = true;
        this.dialogCodigoAuth = true;
      } else {
        this.isCard = false;
        this.codAuth = 0;
        this.bandeira = 0;
        this.dialogCodigoAuth = true;
      }
    },
    async marcarPago(codauth, bandeira) {
      this.loading = true;
      const item = await JSON.parse(localStorage.getItem("itemComanda"));

      this.comandaService
        .pagarItemComanda({
          comandaId: item.comanda_id,
          comandaItemId: item.comanda_item_id,
          idFormaPagamento: this.formaPagamentoSelecionada[
            item.comanda_item_id
          ],
          codauth: parseInt(codauth),
          bandeira: bandeira,
          parcelas: this.parcelas,
          observacao: this.observacao,
        })
        .finally(() => {
          this.loading = false;
          this.dialogCodigoAuth = false;
          this.setComandaItens();
        })
        .catch(() => {
          this.$_ACTIONS_showSnackbarMessage({
            message: this.$global.messages.internalServerError,
            color: "error",
          });
        });
    },
    excluirItemComanda(item) {
      this.loading = true;
      this.comandaService
        .excluirItemComanda({
          comandaId: item.comanda_id,
          comandaItemId: item.comanda_item_id,
        })
        .then(async (resp) => {
          const response = await resp.json();
          this.$_ACTIONS_showSnackbarMessage({
            message: response.message ?? "Excluido com sucesso",
            color: "sucess",
          });
        })
        .finally(() => {
          this.loading = false;
          this.setComandaItens();
        })
        .catch((err) => {
          console.error(err);
          this.$_ACTIONS_showSnackbarMessage({
            message: err.message ?? this.$global.messages.internalServerError,
            color: "error",
          });
        });
    },
    showDialogEstorno() {
      this.valorEstorno = null;
      this.tipoEstornoSelecionado = {};
      // Alterar Caixa
      this.extornarItens();
      // this.dialogEstorno = true;
    },
    estornar() {
      // console.log(this.itemEstorno);
      if (
        parseFloat(this.valorEstorno) + this.valorTotalEstornado >
        parseFloat(this.valorPagoComanda)
      ) {
        this.$_ACTIONS_showSnackbarMessage({
          message: "Valor estornado deve ser menor que o valor pago",
          color: "error",
        });
        return;
      }

      // if ((this.tipoEstornoSelecionado.id == 1) & !this.forma_devolucao) {
      //   this.$_ACTIONS_showSnackbarMessage({
      //     message: 'O campo "forma de devolução" é obrigatório',
      //     color: "error",
      //   });
      //   return;
      // }

      const estorno = {
        comanda_id: parseInt(this.comanda.comanda_id),
        tipo_id: this.tipoEstornoSelecionado.id,
        valor: this.estornarValorTotal,
        observacao: this.observacoesEstorno,
        itens: this.itemsEstorno,
      };

      const responseFunction = {
        onSucess: (status) => async (body) => {
          if (status == 200) {
            this.$_ACTIONS_showSnackbarMessage({
              message: "Estorno lançado com sucesso",
              color: "success",
            });
            const resp = await body.data;
            const estornoId = resp.extorno.id_extorno;
            await this.reciboEstornoPDF(estornoId);
          } else if (status === 428) {
            this.$_ACTIONS_showSnackbarMessage({
              message: "Sem caixa ou Caixa de outra unidade",
              color: "blue",
            });
          } else {
            let itensExecutados = [];
            body.itens.forEach((item) => {
              itensExecutados.push(
                this.desserts.filter((i) => i.comanda_item_id == item)[0]
                  .procedimento_descricao
              );
            });

            this.$_ACTIONS_showSnackbarMessage({
              message: body.message + ": " + itensExecutados.join(", "),
              color: "error",
            });
          }
        },
        onError: () => {},
        onEnd: () => {
          this.loadingEstorno = false;
          this.dialogEstorno = false;
          this.itemsEstorno = [];
          this.setComandaItens();
          this.valoresEstornados();
        },
      };

      // console.log(estorno);

      this.loadingEstorno = true;

      this.estornoService.setEstorno(responseFunction, estorno);
    },
    valueRule(value) {
      if (!value) {
        return "Campo Obrigatório";
      }
    },
    async getTiposEstorno() {
      await this.tipoEstornoService
        .getTipoEstornoPaginatedList({
          page: null,
          per_page: null,
          sort: null,
          desc: null,
          search: null,
        })
        .then(async (response) => {
          if (response.status !== 200) return;
          const { data } = await response.json();
          const { tipo_procedimentos } = data;
          this.tiposEstorno = tipo_procedimentos.map(({ id, descricao }) => {
            return {
              id,
              descricao,
            };
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    valoresEstornados() {
      this.estornoService
        .getEstornoByComandaId(this.comanda.comanda_id)
        .then((resp) => {
          this.valorTotalEstornado = resp.data.estornos.reduce(
            (acc, cur) => acc + parseFloat(cur.valor),
            0
          );
        });
    },
    pagarItens() {
      this.infoCaixa = {};
      this.acao = "";
      // Alterar Caixa
      // this.dialogPagarComandas = true;

      this.caixaService
        .checkCaixaByUser(this.usuarioLogada, this.unidadeLogada)
        .then(async (resp) => {
          const response = await resp.json();
          if (resp.status === 200) {
            this.infoCaixa = response;
            this.dialogPagarComandas = true;
          } else if (resp.status === 206) {
            this.$_ACTIONS_showSnackbarMessage({
              message: response.message ?? "Sem caixa",
              color: "blue",
            });
            this.acao = "pagar";
            this.dialogPagarComandas = false;
            this.dialogAbrirCaixa = true;
          } else if (resp.status === 428) {
            this.$_ACTIONS_showSnackbarMessage({
              message: response.message ?? "Sem caixa",
              color: "blue",
            });
            this.acao = "pagar";
            this.dialogPagarComandas = false;
            this.dialogAbrirCaixa = true;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
    },
    extornarItens() {
      this.infoCaixa = {};
      this.acao = "";
      this.caixaService
        .checkCaixaByUser(this.usuarioLogada, this.unidadeLogada)
        .then(async (resp) => {
          const response = await resp.json();
          if (resp.status === 200) {
            this.infoCaixa = response;
            this.dialogEstorno = true;
          } else if (resp.status === 206) {
            this.$_ACTIONS_showSnackbarMessage({
              message: response.message ?? "Sem caixa",
              color: "blue",
            });
            this.acao = "extorno";
            this.dialogEstorno = false;
            this.dialogAbrirCaixa = true;
          } else if (resp.status === 428) {
            this.$_ACTIONS_showSnackbarMessage({
              message: response.message ?? "Sem caixa",
              color: "blue",
            });
            this.acao = "extorno";
            this.dialogEstorno = false;
            this.dialogAbrirCaixa = true;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
    },
    // async pagarItens() {
    //   await this.checkCaixa();
    //   console.log(this.infoCaixa.id);
    //   if (this.infoCaixa.id) {
    //     this.dialogPagarComandas = true;
    //   } else {
    //     this.dialogPagarComandas = false;
    //     this.dialogAbrirCaixa = true;
    //   }
    // },
    caixaAberto() {
      ExternoEvento.$emit("checkCaixa");
      this.dialogAbrirCaixa = false;
      if (this.acao == "pagar") {
        this.pagarItens();
      }
      if (this.acao == "extorno") {
        this.extornarItens();
      }
    },
    itensPagos() {
      this.dialogPagarComandas = false;
      this.selected = [];
      this.setComandaItens();
    },
    desconto() {
      let valor = 0;
      for (let index = 0; index < this.dessertsPago.length; index++) {
        const element = this.dessertsPago[index];
        if (element.comanda_item_status_id == 2) {
          valor = valor + element.valor_cobrado;
        }
      }
      return valor;
    },
    convertMoeda(valor) {
      valor = valor.toString().replaceAll(",", "");
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    },
    checkEstorno(item) {
      for (let index = 0; index < this.itemsEstorno.length; index++) {
        const element = this.itemsEstorno[index];
        if (element.comanda_item_id == item.comanda_item_id) {
          return false;
        }
      }
      return true;
    },
    valorOriginalComanda() {
      let valor = 0;
      for (let index = 0; index < this.desserts.length; index++) {
        const element = this.desserts[index];
        valor = valor + parseFloat(element.valor_original);
      }
      return valor;
    },
  },
  computed: {
    estornarValorTotal() {
      return this.itemsEstorno.reduce((acc, cur) => acc + cur.valor, 0);
    },
    selectedAll() {
      return this.selected.length ==
        this.dessertsAberto.length - this.disabledCount
        ? // return this.selected.length == this.desserts.length - this.disabledCount
          true
        : false;
    },
  },
};
</script>
<style>
.pdf-content {
  font-family: "Times New Roman", Times, serif;
  color: #000;
}
</style>
<style scoped>
.card-comanda-valor {
  display: flex;
  border-radius: 6px;
  flex-direction: column;
  box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.15);
}
.title-card {
  color: white;
  border-radius: 6px 6px 0px 0px;
  widows: 100%;
  padding: 6px 12px 2px;
  font-weight: bold;
}
.content-card {
  background-color: white;
  padding: 3px 12px 3px;
  border-radius: 0px 0px 6px 6px;
  color: rgb(86, 86, 86);
  font-weight: bold;
}
.color-total .title-card {
  background-color: #171747;
}
.color-total .content-card {
  border: 1px solid #171747;
}
.color-selecionado .title-card {
  background-color: #1daf80;
}
.color-selecionado .content-card {
  border: 1px solid #1daf80;
}
.color-desconto .title-card {
  background-color: #13469f;
}
.color-desconto .content-card {
  border: 1px solid #13469f;
}
.color-estornado .title-card {
  background-color: #ad5a16;
}
.color-estornado .content-card {
  border: 1px solid #ad5a16;
}
.color-pago .title-card {
  background-color: #417c17;
}
.color-pago .content-card {
  border: 1px solid #417c17;
}
.color-credito .title-card {
  background-color: #177c77;
}
.color-credito .content-card {
  border: 1px solid #177c77;
}
.color-cobrado .title-card {
  background-color: #6d1882;
}
.color-cobrado .content-card {
  border: 1px solid #6d1882;
}
</style>
